'use client'

import React from 'react'

import { MImage } from '../../../../core/MImage'
import { cn } from '../../../../utils/cn'

export interface IHeroAImageProps {
	image?: {
		src: string
		alt: string
	}
	className?: string
}

export const HeroAImage: React.FC<IHeroAImageProps> = ({ image, className }) => (
	<div className={cn('m-hero-a__image', className)}>
		{image && <MImage src={image.src} alt={image.alt} className='m-hero-a__image-img' />}
	</div>
)

HeroAImage.displayName = 'AHeroAImage'
